import Layout from '../../internal/Layout.vue'
import calibrationV2 from './index.vue'
import calibrationV2PatternManage from './components/pattern/manage/index.vue'
import calibrationV2TemplateManage from './components/template/manage/index.vue'
import calibrationV2Manage from './components/manage/index.vue'
import calibrationV2CertifiedPrint from './components/certified/print.vue'
import calibrationV2Metric from './components/metric/index.vue'
import calibrationV2Template from './components/standardTemplate/index.vue'
import calibrationV2ManageStandardTemplate from './components/standardTemplate/manage/index.vue'

const calibrationV2Routes = {
  component: Layout,
  children: [
    {
      name: 'calibrationV2ManageStandardTemplate',
      path: '/calibration/v2/standardTemplate/manage',
      component: calibrationV2ManageStandardTemplate,
      meta: {
        module: 'calibracao',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: true,
        requiresCoordSector: false,
        requiresLaboratory: true,
      },
    },
    {
      name: 'calibrationV2Template',
      path: '/calibration/v2/standardTemplate',
      component: calibrationV2Template,
      meta: {
        module: 'calibracao',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: true,
        requiresCoordSector: false,
        requiresLaboratory: true,
      },
    },
    {
      name: 'calibrationV2Metric',
      path: '/calibration/v2/metric',
      component: calibrationV2Metric,
      meta: {
        module: 'calibracao',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: true,
        requiresCoordSector: false,
        requiresLaboratory: true,
      },
    },
    {
      name: 'calibrationV2Manage',
      path: '/calibration/v2/manage',
      component: calibrationV2Manage,
      meta: {
        module: 'calibracao',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: true,
        requiresCoordSector: false,
        requiresLaboratory: true,
      },
    },
    {
      name: 'calibrationV2',
      path: '/',
      component: calibrationV2,
      meta: {
        module: 'calibracao',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: true,
        requiresCoordSector: true,
        requiresLaboratory: true,
      },
    },
    {
      name: 'calibrationV2PatternManage',
      path: '/calibration/v2/pattern/manage',
      component: calibrationV2PatternManage,
      meta: {
        module: 'calibracao',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: false,
        requiresCoordSector: false,
        requiresLaboratory: true,
      },
    },
    {
      name: 'calibrationV2TemplateManage',
      path: '/calibration/v2/template/manage',
      component: calibrationV2TemplateManage,
      meta: {
        module: 'calibracao',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: false,
        requiresCoordSector: false,
        requiresLaboratory: true,
      },
    },
    {
      name: 'calibrationV2CertifiedPrint',
      path: '/calibration/v2/print',
      component: calibrationV2CertifiedPrint,
      meta: {
        module: 'calibracao',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: true,
        requiresCoordSector: true,
        requiresLaboratory: true,
      },
    },
  ],
}

export default calibrationV2Routes
